import { render, staticRenderFns } from "./MoleculeFeedAssetsContentModalCreate.vue?vue&type=template&id=77aa2106&"
import script from "./MoleculeFeedAssetsContentModalCreate.vue?vue&type=script&lang=js&"
export * from "./MoleculeFeedAssetsContentModalCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports